import { createContext, useContext, useEffect, useReducer } from 'react';
import { produce } from 'immer';

import { unimplemented } from '@utils/commonUtils';
import { SCREENS, useMediaQueries } from '@app/hooks/useMediaQueries';

type LayoutKeysType = 'is-sidebar-visible';

type LayoutContextType = {
  isSidebarVisible: boolean;
  setIsSidebarVisible: (val: boolean) => void;
};

type Action = {
  type: LayoutKeysType;
  payload: boolean;
};

const initialState: LayoutContextType = {
  isSidebarVisible: true,
  setIsSidebarVisible: unimplemented,
};

const LAYOUT_CONTEXT_KEYS = {
  IS_SIDEBAR_VISIBLE: 'is-sidebar-visible' as LayoutKeysType,
};

const LayoutContext = createContext(initialState);

const reducer = produce((draft: LayoutContextType, action: Action) => {
  const { type, payload } = action;
  switch (type) {
    case LAYOUT_CONTEXT_KEYS.IS_SIDEBAR_VISIBLE:
      draft.isSidebarVisible = payload;
      break;

    default:
      return draft;
  }
});

export const LayoutProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [isMobile] = useMediaQueries(SCREENS.SM);

  const setIsSidebarVisible = (payload: boolean) => {
    dispatch({ type: LAYOUT_CONTEXT_KEYS.IS_SIDEBAR_VISIBLE, payload });
  };

  const values = {
    ...state,
    setIsSidebarVisible,
  };

  useEffect(() => {
    if (isMobile && state.isSidebarVisible) {
      setIsSidebarVisible(false);
    }
  }, [isMobile]);

  return <LayoutContext.Provider value={values}>{children}</LayoutContext.Provider>;
};

export const useLayoutContext = () => useContext(LayoutContext);
